import { Link, useLocation  } from 'react-router-dom';
import { Col, Layout, Row, } from 'antd';
import {  MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined,} from '@ant-design/icons';
import { IconLogo } from "components/assets/icons";
import { URL_HOME, URL_LOGIN, URL_SAMPLE } from 'routes/RouterConfig';
import { OutlinedButton } from 'components/elements';
import { RoundTag } from 'components/elements';
import { getLocalStorage } from 'hooks/useLocalStorage';
import { useAuth } from 'hooks/AuthContext';
// const { SubMenu } = Menu;
const { Header } = Layout;

export const BaseHeader = ({common, setMenu, isMenu, sideHide=false}) => {
  const location = useLocation();
  // const pathname = location.pathname;
  // const [type, setType] = useState(localStorage.getItem('userType'))

  const { user, logout } = useAuth();

  const logoutStyle = { 
    color : 'var(--color-qmir-yellow)',
    borderRadius : '6px',
    borderColor: 'transparent',
  }

  return (
    <Header className="layout-header">
      <Row>
        { !sideHide && 
        <Col span={1}>
          <div className='layout-logo'>
            <Link onClick={() => setMenu(!isMenu)} style={{marginTop: '4px'}}>
              {
                isMenu ?
                <MenuFoldOutlined style={{ color: 'white', fontSize: '200%' }} />
                :
                <MenuUnfoldOutlined style={{ color: 'white', fontSize: '200%' }} />
              }
            </Link>
          </div>
        </Col>
        }
        <Col span={13}>
          <Link to={URL_HOME}>
            <div className="layout-logo">
              <IconLogo width='55px'/> 
              큐미르 인트라넷
            </div>
          </Link>
        </Col>
        <Col span={10} className="layout-header-submenu">
        {
          !sideHide && (
            <>
              {getLocalStorage('persist:user').level_no === 1 && (
                <>
                  <RoundTag label={<span className='label-hq'>본사</span>} color={'#7FB5F1'} />
                  <Link to={'/admin/account'}>{user.user_name}({user.user_id})</Link>
                </>
              )}

              {getLocalStorage('persist:user').level_no === 2 && (
                <>
                  <RoundTag label={<span className='label-branch'>지사</span>} color={'#81DE84'} />
                  <Link to={'/branch/account'}>{user.user_name}({user.user_id})</Link>
                </>
              )}

              {getLocalStorage('persist:user').level_no === 3 && (
                <>
                  <RoundTag label={<span className='label-school'>교육원</span>} color={'#FFDE88'} />
                  <Link to={'/school/account'}>{user.user_name}({user.user_id})</Link>
                </>
              )}

              {getLocalStorage('persist:user').level_no === 4 && (
                <>
                  <RoundTag label={<span className='label-sptp'>강사</span>} color={'#FFAFAF'} />
                  <Link to={'/school/account'}>{user.user_name}({user.user_id})</Link>
                </>
              )}

              {getLocalStorage('persist:user').level_no === 5 && (
                <>
                  <RoundTag label={<span className='label-sptp'>SPTP 관리자</span>} color={'#FFAFAF'} />
                  <Link to={'/sptp/account'}>{user.user_name}({user.user_id})</Link>
                </>
              )}

              {getLocalStorage('persist:user').level_no === 6 && (
                <>
                  <RoundTag label={<span className='label-post'>배송 관리자</span>} color={'#E1AFFF'} />
                  <Link to={'/post/account'}>{user.user_name}({user.user_id})</Link>
                </>
              )}
            </>
          )
        }

          {!sideHide && 
            <>
              <UserOutlined style={{ marginLeft: '4px' }} />
              <Link to={URL_LOGIN}><OutlinedButton label="로그아웃" onClick={logout} {...logoutStyle} /></Link>
            </>
          }
        </Col>
      </Row>
    </Header>
  );
};
